import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router";
import * as Sentry from "@sentry/react";
import "./index.css";
import { appRouter } from "./App";
import React from "react";
import { datadogRum } from "@datadog/browser-rum";
import GrowthBookWrapper from "./growthbook";
import { DATADOG_RUM } from "./constants";
import { initPostHog } from "./lib/posthog";

initPostHog();

Sentry.init({
  enabled: import.meta.env.VITE_SENTRY_DISABLED !== "true",
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", import.meta.env.VITE_CONNECT_API_BASE_URL],
  // Performance Monitoring - reduced to 1% sampling in production to control costs
  tracesSampleRate: import.meta.env.PROD ? 0.01 : 1.0,
  // Session Replay
  replaysSessionSampleRate: 0.01, // 1% sample rate for session replay
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  ignoreErrors: [
    // Browser extensions (e.g. LastPass, password managers)
    "top.GLOBALS",
    "Object Not Found Matching Id",
    // Network errors from user connection issues
    "Network request failed",
    "NetworkError",
    "Failed to fetch",
    "Load failed",
    // ResizeObserver (benign)
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    // Chunk loading (deployment race condition)
    "ChunkLoadError",
    "Loading chunk",
  ],
});

// Noise emitted by email/link-security scanners (e.g. Outlook SafeLinks/ATP)
// that pre-render URLs from inboxes. Their injected script fails against our
// SPA and throws this; it is not a real Connect error. Sentry already ignores
// the same string (see Sentry.init ignoreErrors above).
const RUM_IGNORED_ERROR_MESSAGES = ["Object Not Found Matching Id"];

datadogRum.init({
  ...DATADOG_RUM,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "mask-user-input",
  beforeSend: (event) => {
    if (event.type === "error" && RUM_IGNORED_ERROR_MESSAGES.some((needle) => event.error.message?.includes(needle))) {
      return false;
    }
    return true;
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <GrowthBookWrapper>
      <RouterProvider router={appRouter} />
    </GrowthBookWrapper>
  </React.StrictMode>,
);
